import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { inscricaoMunicipalMask, inscricaoEstadualMask, cnpjMaskView } from 'utils/masks';
import * as S from './styles';

export default function PessoaJuridica({ dados }) {
  return (
    <Row>
      <S.ContainerLabelValor>
        <S.Label>Cargo do Representante</S.Label>
        <S.Valor>{dados?.cargoRepresentante}</S.Valor>
      </S.ContainerLabelValor>

      <S.ContainerLabelValor>
        <S.Label>Razão Social</S.Label>
        <S.Valor>{dados?.razaoSocial}</S.Valor>
      </S.ContainerLabelValor>

      <S.ContainerLabelValor>
        <S.Label>CNPJ</S.Label>
        <S.Valor>{cnpjMaskView(dados?.cnpj)}</S.Valor>
      </S.ContainerLabelValor>

      <S.ContainerLabelValor>
        <S.Label>Inscrição Estadual</S.Label>
        <S.Valor>{inscricaoEstadualMask(dados?.inscricaoEstadual)}</S.Valor>
      </S.ContainerLabelValor>

      <S.ContainerLabelValor>
        <S.Label>Inscrição Municipal</S.Label>
        <S.Valor>{inscricaoMunicipalMask(dados?.inscricaoMunicipal)}</S.Valor>
      </S.ContainerLabelValor>

      <S.ContainerLabelValor>
        <S.Label>Tipo de Instituição</S.Label>
        <S.Valor>{dados?.instituicao}</S.Valor>
      </S.ContainerLabelValor>

      <S.ContainerLabelValor>
        <S.Label>Área de Atuação</S.Label>
        <S.Valor>{dados?.areaAtuacao}</S.Valor>
      </S.ContainerLabelValor>
    </Row>
  );
}

PessoaJuridica.propTypes = {
  dados: PropTypes.object,
};
